<template>
    <div class="card shadow"
         :class="type === 'dark' ? 'bg-default': ''">
        <div class="card-header border-0"
             :class="type === 'dark' ? 'bg-transparent': ''">
            <div class="row align-items-center">
                <div class="col">
                    <base-button
                        v-if="currentUser && currentUser.roles.indexOf('client_admin') !== -1 && currentUser.roles.indexOf('rio_user') === -1"
                        @click.prevent="newUser = true" type="success"><i class="fad fa-plus-circle"></i>
                        Benutzer importieren
                    </base-button>
                    <base-button
                        v-if="currentUser &&  currentUser.roles.indexOf('user_admin') !== -1"
                        @click.prevent="newClient = true" type="success"><i class="fad fa-plus-circle"></i>
                        Admins importieren
                    </base-button>

                    <!--                    <base-alert v-if="currentUser && currentUser.roles.indexOf('client_admin') !== -1 && currentUser.roles.indexOf('rio_user') === -1"-->
                    <!--                                type="info">-->
                    <!--                        <span class=""><strong>Info: </strong>Berechtigungen werden von Ihrem Admin erteilt. </span>-->
                    <!--                    </base-alert>-->
                    <!--                    <base-alert v-if="currentUser &&  currentUser.roles.indexOf('user_admin') !== -1"-->
                    <!--                                type="info">-->
                    <!--                        <span class=""><strong>Info: </strong>Wenn Benutzer fehlen, wenden Sie sich an unsere <a href="https://www.talus.ch/de/support/">Supportline</a>.</span>-->
                    <!--                    </base-alert>-->

                    <modal data-backdrop="static"
                           id="modalUserImport"
                           v-if="currentUser && (currentUser.roles.indexOf('client_admin') !== -1 || currentUser.roles.indexOf('user_admin') !== -1)"
                           v-model:show="newUser" @close="clearRoles" @open="setCRM"
                           modal-classes="modal-lg modal-dialog-centered">
                        <template v-slot:header>
                            <h4 class="modal-title" id="userModalLabel">Benutzer importieren</h4>
                        </template>
                        <div v-if="currentUser.roles.indexOf('client_admin') !== -1">
                            <div class="row mb-3">
                                <div class="col">
                                    <h3>Es können nur Benutzer welche im Talus CRM hinterlegt sind importiert
                                        werden</h3>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col">
                                <el-select class="btn-block" v-model="selectUsers"
                                           placeholder="Benutzer auswählen"
                                           filterable multiple @change="checkAll"
                                           no-match-text="Kein Kunde gefunden" required="required">
                                    <el-option key="0" value="All" label="Alle auswählen/abwählen"
                                               class="all-options"></el-option>
                                    <el-option class="select-primary" v-for="contactEntry in filteredContacts"
                                               :key="contactEntry.contactId"
                                               :label="(contactEntry.firstName + ' ' + contactEntry.lastName + ' (' + contactEntry.email + ')')"
                                               :value="contactEntry.email"></el-option>
                                </el-select>
                                <small class="errorText" v-if="errorUserText.length > 0">{{
                                        errorUserText
                                    }}</small>
                            </div>
                        </div>
                        <div class="row mt-4 mb-3 pr-3 pl-3">
                            <div class="w-100"><h4>Standardgruppen auswählen</h4></div>
                            <ul class="list-group list w-100">
                                <li class="list-group-item" v-for="(role, index) in filteredRoles"
                                    :key="index + '_first'">
                                    <div class="row align-items-center">


                                        <div class="col">
                                            <h5 class="mb-0">
                                                {{ role.description }}
                                            </h5>
                                        </div>
                                        <div class="col text-right">
                                            <base-switch onText="" offText="" type="primary" :modelValue="role.status"
                                                         @changed="setRoleStatus(role.id, $event)"></base-switch>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <template v-slot:footer>
                            <base-button
                                v-if="!loading"
                                v-bind:disabled="disabled" @click.prevent="createUsers" type="success"
                                class="btn-block mt--4">
                                Importieren
                            </base-button>
                            <div class="container mt--4" v-if="loading">
                                <div class="loaderInfo"><img class="loader" src="img/loading.gif" alt="loader"></div>
                            </div>
                        </template>
                    </modal>
                    <modal data-backdrop="static"
                           id="modalClientImport"
                           v-if="currentUser && currentUser.roles.indexOf('user_admin') !== -1"
                           v-model:show="newClient" @close="clearRoles" modal-classes="modal-lg modal-dialog-centered">
                        <template v-slot:header>
                            <h4 class="modal-title" id="clientModalLabel">Admins importieren</h4>
                        </template>
                        <div class="row mb-3">
                            <div class="col">
                                <el-select class="btn-block" v-model="selectClients"
                                           placeholder="Abacus Kunden auswählen (optional / Keine Angabe = Alle)"
                                           filterable multiple
                                           no-match-text="Kein Kunde gefunden" required="required">
                                    <el-option class="select-primary" v-for="clientEntry in filteredClients"
                                               :key="clientEntry.id" :label="clientEntry.name"
                                               :value="clientEntry.id"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <template v-slot:footer>
                            <base-button
                                v-if="!loading"
                                v-bind:disabled="disabled" @click.prevent="createClients" type="success"
                                class="btn-block mt--4">
                                Importieren
                            </base-button>
                            <div class="container mt--4" v-if="loading">
                                <div class="loaderInfo"><img class="loader" src="img/loading.gif" alt="loader"></div>
                            </div>
                        </template>
                    </modal>
                </div>
                <div class="col">
                </div>
                <div class="col text-right">
                    <el-input type="search" class="" clearable prefix-icon="el-icon-search" style="width: 250px"
                              placeholder="Suche" v-model="search" aria-controls="datatables"></el-input>
                </div>
            </div>
        </div>
        <modal
            id="modalPermission"
            v-if="currentUser && (currentUser.roles.indexOf('client_admin') !== -1 || currentUser.roles.indexOf('user_admin') !== -1)"
            v-model:show="showPermission" @close="clearRoles" modal-classes="modal-lg modal-dialog-centered">
            <template v-slot:header>
                <h4 class="modal-title" id="permissionModalLabel">Benutzer berechtigen</h4>
            </template>
            <div class="row mb-3 pr-3 pl-3">
                <ul class="list-group list w-100">
                    <li class="list-group-item" v-for="(role, index) in filteredRoles" :key="index + '_second'">
                        <div class="row align-items-center">
                            <div class="col">
                                <h5 class="mb-0">
                                    {{ role.description }}
                                </h5>
                            </div>
                            <div class="col text-right">
                                <base-switch onText="" offText="" type="primary" :modelValue="role.status"
                                             @changed="setRoleStatus(role.id, $event)"></base-switch>
                            </div>
                        </div>
                    </li>
                    <li class="list-group-item">
                        <div class="row align-items-center">
                            <div class="col">
                                <h5 class="mb-0">
                                    Servicedesk Admin
                                </h5>
                            </div>
                            <div class="col text-right">
                                <base-switch onText="" offText="" type="primary" :modelValue="isServiceDeskAdmin"
                                             @changed="setServiceDeskAdminRoleStatus($event)">
                                </base-switch>
                            </div>
                        </div>
                    </li>
                </ul>
            </div >

            <template v-slot:footer>
                <base-button v-bind:disabled="disabled" @click.prevent="setPermission" type="success"
                             class="btn-block mt--4">
                    Speichern
                </base-button>
            </template>
        </modal>
        <div class="table-responsive">
            <el-table class="table-responsive" :default-sort="{ prop: 'lastName', order: 'ascending' }"
                      empty-text="Keine Einträge vorhanden" @sort-change="changeSort" :data="filteredUsers">
                <el-table-column prop="username" :sort-orders="['ascending', 'descending']" label="Benutzer"
                                 min-width="170px" sortable>
                    <template v-slot="{ row }">
                        {{ (row.username) ? row.username : '' }}
                    </template>
                </el-table-column>
                <el-table-column prop="lastName" :sort-orders="['ascending', 'descending']" label="Nachname"
                                 min-width="136px" sortable>
                    <template v-slot="{ row }">
                        {{ (row.lastName) ? row.lastName : '' }}
                    </template>
                </el-table-column>
                <el-table-column prop="firstName" :sort-orders="['ascending', 'descending']" label="Vorname"
                                 min-width="136px" sortable>
                    <template v-slot="{ row }">
                        {{ (row.firstName) ? row.firstName : '' }}
                    </template>
                </el-table-column>
                <el-table-column prop="admin" :sort-orders="['ascending', 'descending']" label="Admin" min-width="136px"
                                 sortable>
                    <template v-slot="{ row }">
                        <i v-if="isAdminButton(row)" class="fad fa-users"/>
                    </template>
                </el-table-column>
                <el-table-column
                    v-if="(currentUser.roles.indexOf('user_admin') !== -1 || currentUser.roles.indexOf('rio_user') === -1)"
                    prop="token" label="Login-Token" min-width="136px">
                    <template v-slot="{ row }">
                        <button class="btn btn-sm btn-info" title="Login-Token in die Zwischenablage"
                                v-if="row.attributes.loginToken" @click.stop="getToken(row.attributes.loginToken)">
                            <i class="fad fa-qrcode"/>
                        </button>
                    </template>
                </el-table-column>
                <el-table-column prop="buttons" label="Aktionen" min-width="370px" class-name="cell-overflow-visible"
                                 cell-class-name="overflow-visible">
                    <template v-slot="{ row }">
                        <div class="d-flex align-items-center">
                            <span role="button" class="actionButton bg-light"
                                  v-if="!row.attributes.loginToken && (currentUser.roles.indexOf('user_admin') !== -1 || currentUser.roles.indexOf('rio_user') === -1)"
                                  @click="setToken(row)"
                                  title="Login-Token generieren"><i class="fad fa-qrcode"/> Login-Token generieren
                            </span>
                            <span role="button" class="actionButton bg-light" @click="openPermission(row)"
                                  title="Berechtigungen setzen"
                            ><i class="fad fa-user-shield"/> Berechtigungen setzen
                            </span>
<!--                            <span role="button" class="actionButton bg-light"
                                  v-if="currentUser.roles.indexOf('user_admin') !== -1"
                                  @click="impersonateUser(row)" title="Als Benutzer einloggen"
                            ><i class="fad fa-user-secret"/> Als Benutzer einloggen
                                                        </span>-->
                            <span role="button" class="actionButton bg-light" @click="deleteUser(row)"
                                  title="Benutzer löschen"><i
                                class="fad fa-trash"/> Benutzer löschen
                            </span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="card-footer d-flex justify-content-end"
             :class="type === 'dark' ? 'bg-transparent': ''">
            <base-pagination v-model="pagination" :total="total" :perPage="perPage"></base-pagination>
        </div>
        <base-alert v-if="error.length > 0" type="danger">
            <span class="alert-inner--text"><strong>Fehler!</strong>  {{ error }}</span>
        </base-alert>
    </div>
</template>
<script>
import {ref, computed, watch, onMounted} from 'vue';
import swal from 'sweetalert2';
import UserService from '@/services/user.service';
import Modal from "@/components/Modal";
import ButtonCheckbox from "@/components/ButtonCheckbox";
import BaseAlert from "@/components/BaseAlert";
import BaseButton from "@/components/BaseButton";
import BaseSwitch from "@/components/BaseSwitch";
import {useStore} from 'vuex'
import {
    ElTable,
    ElTableColumn,
    ElDropdownMenu,
    ElDropdownItem,
    ElDropdown,
    ElInput,
    ElSelect,
    ElOption
} from "element-plus";
import {store} from "../../store";

export default {
    name: 'users-table',
    components: {
        Modal,
        BaseAlert,
        BaseSwitch,
        BaseButton,
        ButtonCheckbox,
        [ElTable.name]: ElTable,
        [ElTableColumn.name]: ElTableColumn,
        [ElDropdown.name]: ElDropdown,
        [ElDropdownItem.name]: ElDropdownItem,
        [ElDropdownMenu.name]: ElDropdownMenu,
        [ElInput.name]: ElInput,
        [ElSelect.name]: ElSelect,
        [ElOption.name]: ElOption,
    },
    props: {
        type: {
            type: String
        },
    },
    setup(props, {emit}) {
        const store = useStore();
        const currentUser = computed(() => store.state.auth.user);

        const users = ref([]);
        const search = ref('');
        const pagination = ref(1);
        const total = ref(0);
        const start = ref(0);
        const perPage = ref(10);
        const filteredUsers = computed(() => {
            if (search.value === '') {
                total.value = users.value.length;
                return users.value.filter((item, idx) => (idx >= start.value && idx < start.value + perPage.value));
            } else {
                const entries = users.value.filter(item => {
                    let props = Object.values(item);
                    return props.some(prop => !search.value.toLowerCase() || ((typeof prop === 'string') ? prop.toLowerCase().includes(search.value.toLowerCase()) : prop.toString(10).toLowerCase().includes(search.value.toLowerCase())))
                });
                total.value = entries.length;
                return entries.filter((item, idx) => (idx >= start.value && idx < start.value + perPage.value));
            }
        });

        watch(pagination, () => {
            start.value = (pagination.value - 1) * perPage.value;
        });

        const currentSort = ref('lastName');
        const currentSortDir = ref('ascending');

        function changeSort(sort) {
            currentSort.value = (!sort.prop) ? '' : sort.prop;
            currentSortDir.value = (!sort.order) ? '' : sort.order;
            sortTable();
        }

        function sortTable() {
            users.value.sort((a, b) => {
                let modifier = 1;
                if (currentSortDir.value === 'descending') modifier = -1;
                if (currentSort.value === 'admin') {
                    return (isAdminButton(a) === isAdminButton(b)) ? 0 : isAdminButton(a) ? -1 * modifier : modifier;
                }
                if (a[currentSort.value] < b[currentSort.value]) return -1 * modifier;
                if (a[currentSort.value] > b[currentSort.value]) return modifier;
                return 0;
            });
        }

        const roles = ref([]);
        const roleClientId = ref(0);

        function setRoleStatus(id, value) {
            const roleKey = roles.value.findIndex(x => x.id === id);
            roles.value[roleKey].status = value;
        }

        const filteredRoles = computed(() => {
            if (roleClientId.value === 0) {
                return roles.value;
            } else {
                return roles.value.filter(role => {
                    const clientIndex = clients.value.map(obj => obj.id).indexOf(roleClientId.value);
                    if (clientIndex !== -1) {
                        return clients.value[clientIndex].roles[role.name];
                    }
                });
            }
        });

        const serviceDeskAdminRoleOfUserBeingEdited = ref([]) // holds topdesk_branches attribute
        // used for setting state of switch in template
        const isServiceDeskAdmin = computed(() => {
            return !!serviceDeskAdminRoleOfUserBeingEdited.value
        })
        const becomeServiceDeskAdmin = ref(Boolean) // flag to be used in setPermission()
        const setServiceDeskAdminRoleStatus = (value) => {
            becomeServiceDeskAdmin.value = value;
        }

        const error = ref('');
        function getError(errorText) {
            if (errorText.response && errorText.response.status === 401) {
                error.value = 'you are not logged in!';
            } else if (errorText.response && errorText.response.status === 403) {
                error.value = 'you are not permitted!';
            } else {
                error.value =
                    (errorText.response && errorText.response.data) ||
                    errorText.message ||
                    errorText.toString();
            }
        }

        const totalEntries = ref(0);
        const disabled = ref(true);

        function getUsers() {
            UserService.getUsers().then(
                response => {
                    users.value = response.data.data.filter(entry => entry.firstName !== "TOK" && entry.lastName !== "Admin");
                    sortTable(currentSort.value);
                    totalEntries.value = users.value.length;
                    error.value = '';
                    disabled.value = false;
                    emit('changed', users.value);
                },
                error => {
                    getError(error);
                }
            );
        }

        async function copyText(text) {
            try {
                await navigator.clipboard.writeText(text);
            } catch ($e) {
                console.log("Error on copying");
            }
        }

        function getToken(token) {
            copyText(token);
            swal.fire({
                icon: 'success',
                title: 'Login Token ist nun in der Zwischenablage',
                showConfirmButton: false,
                timer: 2000
            });
        }

        function setToken(user) {
            UserService.generateToken(user.id).then(
                response => {
                    if (!response) {
                        throw new Error(response.statusText)
                    }
                    getUsers();
                    error.value = '';
                    return response.message
                },
                error => {
                    getError(error);
                }
            );
        }

        function setClientAdmin(user) {
            swal.fire({
                icon: 'warning',
                title: `Den Benutzer wirklich zum Administrator befördern?`,
                text: "Bestätigen durch Eingabe vom Benutzer!",
                buttonsStyling: false,
                customClass: {
                    confirmButton: 'btn btn-warning btn-fill',
                    cancelButton: 'btn btn-secondary btn-fill'
                },
                input: 'text',
                inputAttributes: {
                    autocapitalize: 'off'
                },
                showCancelButton: true,
                cancelButtonText: 'Schliessen',
                confirmButtonText: 'befördern',
                showLoaderOnConfirm: true,
                preConfirm: (username) => {
                    if (username === user.email) {
                        UserService.setAdmin(user.id)
                            .then(
                                response => {
                                    if (!response) {
                                        throw new Error(response.statusText)
                                    }
                                    error.value = '';
                                    return response.message
                                },
                                error => {
                                    getError(error);
                                }
                            ).catch(error => {
                            swal.showValidationMessage(
                                `Request failed: ${error}`
                            )
                        })
                    } else {
                        swal.showValidationMessage(
                            `Benutzer ist nicht korrekt`
                        )
                    }
                },
                allowOutsideClick: () => !swal.isLoading()
            }).then((result) => {
                if (result.isConfirmed) {
                    swal.fire({
                        icon: 'success',
                        title: `Benutzer wurde zum Admin befördert!`,
                        buttonsStyling: false,
                        customClass: {
                            confirmButton: 'btn btn-secondary btn-fill'
                        },
                        allowOutsideClick: false
                    }).then((result) => {
                        if (result.isConfirmed) {
                            getUsers();
                        }
                    })
                }
            })
        }

        function deleteUser(user) {
            swal.fire({
                icon: 'warning',
                title: `Den Benutzer wirklich löschen?`,
                text: "Zum Löschen Benutzer eingeben!",
                buttonsStyling: false,
                customClass: {
                    confirmButton: 'btn btn-danger btn-fill',
                    cancelButton: 'btn btn-secondary btn-fill'
                },
                input: 'text',
                inputAttributes: {
                    autocapitalize: 'off'
                },
                showCancelButton: true,
                cancelButtonText: 'Schliessen',
                confirmButtonText: 'Löschen',
                showLoaderOnConfirm: true,
                preConfirm: (username) => {
                    if (username === user.email) {
                        UserService.deleteUser(user.id)
                            .then(
                                response => {
                                    if (!response) {
                                        throw new Error(response.statusText)
                                    }
                                    error.value = '';
                                    return response.message
                                },
                                error => {
                                    getError(error);
                                }
                            ).catch(error => {
                            swal.showValidationMessage(
                                `Request failed: ${error}`
                            )
                        })
                    } else {
                        swal.showValidationMessage(
                            `Benutzer ist nicht korrekt`
                        )
                    }
                },
                allowOutsideClick: () => !swal.isLoading()
            }).then((result) => {
                if (result.isConfirmed) {
                    swal.fire({
                        icon: 'success',
                        title: `Benutzer wurde gelöscht!`,
                        buttonsStyling: false,
                        customClass: {
                            confirmButton: 'btn btn-secondary btn-fill'
                        },
                        allowOutsideClick: false
                    }).then((result) => {
                        if (result.isConfirmed) {
                            getUsers();
                        }
                    })
                }
            })
        }

        const client = ref('');
        const clients = ref([]);
        const selectClients = ref([]);
        const selectUsers = ref([]);
        const newClient = ref(false);
        const newUser = ref(false);

        function getClients() {
            if (currentUser.value.roles.indexOf('user_admin') !== -1) {
                UserService.getClients().then(
                    response => {
                        clients.value = response.data.data.filter(entry => entry.addressType === "Organisation" && entry.client_talus === 1).map(entry => {
                            let client = {};
                            client.id = entry.id;
                            client.name = entry.lastName;
                            client.roles = {
                                rio_user: !!entry.client_rio,
                                abacus_user: !!entry.client_talus,
                                aba_user: !!entry.client_abacus,
                                topdesk_user: !!entry.client_talus
                            };
                            error.value = '';
                            return client;
                        }).sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
                    },
                    error => {
                        getError(error);
                    }
                );
            } else {
                UserService.getCustomer(parseInt(currentUser.value.clientId)).then(
                    response => {
                        let client = {};
                        client.id = response.data.id;
                        client.name = response.data.lastName;
                        client.roles = {
                            rio_user: !!response.data.client_rio,
                            abacus_user: !!response.data.client_talus,
                            aba_user: !!response.data.client_abacus,
                            topdesk_user: !!response.data.client_talus
                        };
                        error.value = '';
                        clients.value = [client];
                    },
                    error => {
                        getError(error);
                    }
                );
            }
        }

        const filteredClients = computed(() => {
            return clients.value.filter(client => {
                return !client.roles.rio_user;
            });
        });

        const contacts = ref([]);

        function getContacts() {
            UserService.getContacts().then(
                response => {
                    contacts.value = response.data.data;
                    error.value = '';
                },
                error => {
                    getError(error);
                }
            );
        }

        const filteredContacts = computed(() => {
            return contacts.value.filter(contact => {
                return users.value.map(user => user.email).indexOf(contact.email) === -1;
            });
        });

        function clearRoles() {
            roles.value.map(role => {
                setRoleStatus(role.id, false);
            });
            roleClientId.value = 0;
        }

        function getRoles() {
            UserService.getRoles().then(
                response => {
                    roles.value = response.data.data.map(entry => {
                        let role = {};
                        role.id = entry.id;
                        role.name = entry.name;
                        role.description = entry.description;
                        role.status = false;
                        return role;
                    });
                    error.value = '';
                },
                error => {
                    getError(error);
                }
            );
        }

        const userPermissionId = ref(0);
        // temp - remove later

        const showPermission = ref(false);

        function openPermission(user) {
            // set Ids and get roles for the selected user
            roleClientId.value = parseInt(user.attributes.clientId[0]);
            userPermissionId.value = user.id;
            UserService.getRolesOfUser(user.id).then(
                response => {
                    roles.value.map(role => {
                        if (response.data.data.map(item => item.id).includes(role.id)) {
                            setRoleStatus(role.id, true);
                        }
                    });
                    showPermission.value = true;
                    error.value = '';
                },
                error => {
                    getError(error);
                }
            );

            // get the branch attributes for the selected user
            UserService.getBranchesOfUser(userPermissionId.value).then(
                response => {
                    serviceDeskAdminRoleOfUserBeingEdited.value = response.data.topdesk_branches
                }
            )
        }


        function setPermission() {
            const clientRoles = filteredRoles.value.filter(entry => entry.status === true).map(entry => {
                let role = {};
                role.id = entry.id;
                role.name = entry.name;
                role.description = entry.description;
                return role;
            });
            UserService.setRoles(userPermissionId.value, clientRoles).then(
                () => {
                    if (userPermissionId.value === currentUser.value.sub) {
                        window.location = "/";
                    }
                    showPermission.value = false;
                    clearRoles();
                    error.value = '';
                    swal.fire({
                        icon: 'success',
                        title: 'Berechtigungen wurden gesetzt',
                        showConfirmButton: false,
                        timer: 2000
                    });
                },
                error => {
                    getError(error);
                }
            );

            // set topdesk_branches attribute to become service desk admin
            UserService.setAsTopDeskUser(currentUser.value.sub,  userPermissionId.value).then(
                response => {
                    serviceDeskAdminRoleOfUserBeingEdited.value = response.data.topdesk_branches
                }
            )
        }

        const loading = ref(false);

        function createClients() {
            loading.value = true;
            disabled.value = true;
            const clients = (selectClients.value.length !== 0) ? selectClients.value : filteredClients.value.map(client => client.id)
            UserService.createClients(clients).then(
                response => {
                    getUsers();
                    selectClients.value = [];
                    loading.value = false;
                    newClient.value = false;
                    error.value = '';
                    if (response.data.message) {
                        swal.fire({
                            icon: 'warning',
                            title: 'keine neuen Benutzer gefunden',
                            showConfirmButton: true,
                            confirmButtonText: 'OK',
                            buttonsStyling: false,
                            customClass: {
                                confirmButton: 'btn btn-warning btn-fill',
                            }
                        });
                    } else {
                        swal.fire({
                            icon: 'success',
                            title: 'Benutzer wurden importiert',
                            showConfirmButton: false,
                            timer: 2000
                        });
                    }
                    clearRoles();
                },
                error => {
                    loading.value = false;
                    clearRoles();
                    getError(error);
                }
            );
        }

        const errorUserText = ref('');

        function createUsers() {
            if (selectUsers.value.length === 0) {
                errorUserText.value = 'Bitte mindest einen Benutzer wählen!';
                return false;
            }
            loading.value = true;
            disabled.value = true;
            const clientRoles = filteredRoles.value.filter(entry => entry.status === true).map(entry => {
                let role = {};
                role.id = entry.id;
                role.name = entry.name;
                role.description = entry.description;
                return role;
            });
            UserService.createUsers(selectUsers.value, clientRoles, currentUser.value.clientId).then(
                response => {
                    getUsers();
                    selectUsers.value = [];
                    loading.value = false;
                    newUser.value = false;
                    error.value = '';
                    errorUserText.value = '';
                    if (response.data.message) {
                        swal.fire({
                            icon: 'warning',
                            title: 'keine neuen Benutzer gefunden',
                            showConfirmButton: true,
                            confirmButtonText: 'OK',
                            buttonsStyling: false,
                            customClass: {
                                confirmButton: 'btn btn-warning btn-fill',
                            }
                        });
                    } else {
                        swal.fire({
                            icon: 'success',
                            title: 'Benutzer wurden importiert',
                            showConfirmButton: false,
                            timer: 2000
                        });
                    }
                    clearRoles();
                },
                error => {
                    loading.value = false;
                    clearRoles();
                    getError(error);
                }
            );
        }

        const checkAll = (options) => {
            if (options.indexOf('All') !== -1) {
                if (selectUsers.value.length === (filteredContacts.value.length + 1)) {
                    selectUsers.value = [];
                } else {
                    selectUsers.value = filteredContacts.value.map(user => user.email);
                }
            }
        }

        function setCRM() {
            changeClient(currentUser.value.clientId);
        }

        function isAdminButton(entry) {
            return entry.attributes.clientAdmin && entry.attributes.clientAdmin[0] === '1';
        }

        function changeClient(value) {
            roleClientId.value = parseInt(value);
        }

        const impersonateUser = (user) => {
            UserService.impersonateUser(user).then(
                response => {
                    const user = JSON.stringify(response.data.response.access_token, null, "  ");
                    /*localStorage.setItem('user', user);
                    localStorage.setItem('token', keycloak.token);
                    localStorage.setItem('idToken', keycloak.idToken);
                    store.commit('auth/loginSuccess', JSON.parse(localStorage.getItem('user')), localStorage.getItem('token'), localStorage.getItem('idToken'));
                    //Token Refresh
                    setInterval(() => {
                        keycloak.updateToken(30).then((refreshed) => {
                            if (refreshed) {
                                localStorage.setItem('token', keycloak.token);
                            }
                        }).catch(() => {
                            console.log('Failed to refresh token');
                        });
                    }, 6000)*/
                    swal.fire({
                        icon: 'success',
                        title: 'Benutzer wird nun simuliert',
                        showConfirmButton: false,
                        timer: 2000
                    });
                },
                error => {
                    loading.value = false;
                    clearRoles();
                    getError(error);
                }
            );
        };

        onMounted(() => {
            if (currentUser.value.roles.indexOf('client_admin') !== -1) {
                setCRM();
            }
            getClients();
            getUsers();
            getRoles();
            getContacts();
        });

        return {
            serviceDeskAdminRoleOfUserBeingEdited,
            isServiceDeskAdmin,
            setServiceDeskAdminRoleStatus,
            currentUser,
            impersonateUser,
            search,
            filteredUsers,
            error,
            newClient,
            newUser,
            showPermission,
            openPermission,
            setPermission,
            client,
            filteredClients,
            filteredContacts,
            selectClients,
            selectUsers,
            filteredRoles,
            disabled,
            createClients,
            createUsers,
            errorUserText,
            setRoleStatus,
            clearRoles,
            deleteUser,
            setClientAdmin,
            setToken,
            getToken,
            total,
            pagination,
            perPage,
            changeClient,
            isAdminButton,
            changeSort,
            loading,
            setCRM,
            checkAll
        };
    },
}
;
</script>
<style scoped lang="scss">
:root {
    --ck-border-radius: 0.375rem;
}

.loaderInfo {
    width: 100%;
    padding: 10px;
    text-align: center;
}

.loader {
    height: 100px;
}

.errorText {
    color: #f5365c;
}

.actionButton {
    padding: 5px 20px;
    border-radius: 100px;
}

.actionButton:not(:last-child) {
    margin-right: 5px;
}

thead th {
    cursor: pointer;
}

.all-options {
    font-style: italic;
    opacity: 0.8;
    font-weight: bold;
}

</style>
